export enum ImageType {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}

export enum MemberRole {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER',
  COPYWRITER = 'COPYWRITER',
}

export enum MemberType {
  MEMBER = 'member',
  INVITATION = 'invitation',
  SUSPENDED = 'suspended',
}

export enum ProjectOrigin {
  ORDINARY = 'ordinary',
  AI = 'ai',
  CRAWLED = 'crawled',
  SITEMAP_XML = 'sitemap_xml',
  TEMPLATE = 'template',
  DUPLICATE = 'duplicate',
  IMPORT = 'import',
}

export enum LoginStrategy {
  MODAL_COMMENTS = 'MODAL_COMMENTS',
  MODAL_BLOCK = 'MODAL_BLOCK',
  SAVE_PROJECT = 'SAVE_PROJECT',
  INVITE = 'INVITE',
  JOIN = 'JOIN',
  INVITE_TO_TEAM = 'INVITE_TO_TEAM',
  SUBSCRIBE = 'SUBSCRIBE',
  CHECKOUT = 'CHECKOUT',
  LOGIN = 'LOGIN',
  PROJECT_TRANSFER = 'PROJECT_TRANSFER',
  ANNUAL_SUBSCRIPTION = 'ANNUAL_SUBSCRIPTION',
  AVATAR = 'AVATAR',
}

export enum ProjectBadges {
  SAVE = 'save',
  READONLY = 'readonly',
}

export enum TextSizesLegacy {
  S = 's',
  M = 'm',
  L = 'l',
}

export enum WarningIconType {
  INFO = 'info',
  EXCLAMATION = 'exclamation',
}

export enum SkeletonSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  XM = 'xm',
  L = 'l',
  XL = 'xl',
}

export enum SkeletonType {
  LINE = 'line',
  BOX = 'box',
}
